import React, { ReactNode, RefObject, useEffect, useRef } from 'react';

import { ReactComponent as CloseIcon } from '../../assets/icons/ic_close.svg';

interface AbsoluteModalProps {
  position: string;
  width: string;
  onClose: () => void;
  children: ReactNode;
  darkBg?: boolean;
  hideClose?: boolean;
  clickOutside?: boolean;
  ignoreRefs?: RefObject<HTMLDivElement | HTMLSpanElement>[];
  closePosition?: string;
}

const AbsoluteModal = ({
  position,
  width,
  onClose,
  children,
  darkBg,
  hideClose,
  clickOutside,
  ignoreRefs,
  closePosition,
}: AbsoluteModalProps) => {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      const isIgnored = ignoreRefs?.some((ref) => ref.current && ref.current.contains(e.target as Node));
      if (!isIgnored && ref.current && !ref.current.contains(e.target as Node)) {
        onClose();
      }
    };

    if (clickOutside) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [onClose, clickOutside, ignoreRefs]);

  return (
    <>
      <div
        ref={ref}
        className={`absolute ${position} ${width} z-30 cursor-default rounded-[16px] border border-white bg-white shadow-search md:rounded-[32px]`}
      >
        <CloseIcon
          width={24}
          height={24}
          className={`absolute -top-[-20px] ${closePosition} z-10 cursor-pointer text-[#5F6368] md:h-[34px] md:w-[34px] ${hideClose ? 'hidden' : ''}`}
          onClick={onClose}
        />
        {children}
      </div>
      {darkBg && <div className="fixed inset-0 z-10 bg-black/50" onClick={onClose} />}
    </>
  );
};

export default AbsoluteModal;
